


$(document).ready(function() {
    const e = new Plyr("#player", {});
    console.log(e), window.player = e, $(document).on("click", ".video--play-trigger", function() {
        $(this).parents(".video-wrapper").hide(), $(this).parents(".video-wrapper").next(".responsive-vid").show(), e.play()
    }), 
    $(document).on("click", ".plyr__video-wrapper", function() {
        console.log("hiiii"), 0 == e.fullscreen.active && ($(this).parents(".responsive-vid").prev(".video-wrapper").show(), $(this).parents(".responsive-vid").hide())
    }), 
      window.onresize = function(i) {
        1 == e.paused && ($(".responsive-vid").hide(), $(".video-wrapper").show())
    }, 
      $(".img-text-grid:not(.img_grid_slider)").flickity({
        cellAlign: "left",
        contain: !0,
        wrapAround: !0,
        prevNextButtons: !1,
        watchCSS: !0
    }), 
    $(".quick-links").flickity({
        cellAlign: "center",
        contain: !0,
        wrapAround: !0,
        prevNextButtons: !1,
        watchCSS: !0
    }), 
    $(".step-wrap").flickity({
        cellAlign: "center",
        contain: !0,
        wrapAround: !0,
        prevNextButtons: !1,
        watchCSS: !0
    }),
    $(".feature_text_slider").flickity({
        cellAlign: "center",
        contain: !0,
        wrapAround: !0,
        prevNextButtons: 0,
        watchCSS: 1
    }),
    $(".image_list_slider").flickity({
        cellAlign: "left",
        contain: !0,
        wrapAround: !0,
        autoPlay: !0,
        prevNextButtons: 0,
      lazyLoad: true,
      	pageDots: 0
    })
});